module.exports = __webpack_public_path__ + "img/xjht.d5324e8f.png";